import { apiPaths } from './kepala-sekolah/config'
import { useMutationApi, useQueryApi } from 'utils/api'

import type { UseMutationOptions } from 'react-query'
import type { CommonResponse } from 'types/api'
import type { UQO } from 'types/kinerja-dinas-penilaian'
import type {
  ParamsSyncSkpPerencanaan,
  ResponseSyncSkpPerencanaan,
} from 'types/kinerja-pengaliran'

export type TRequestStatusPengaliranSkp = {
  year: number
  jabatan: 'guru' | 'ks'
}

export type StatusPengaliranSKPSyncStatus = {
  synced: boolean
  success: boolean
  lastSync: string // eg. "2024-10-15T07:08:37.499Z"
  message: string
}

export type StatusPengaliranSKP = {
  asn: boolean
  pengaliran:
    | undefined // Can be either undefined or an empty object if the user is not ASN
    | {} // Can be either undefined or an empty object if the user is not ASN
    | StatusPengaliranSKPSyncStatus
}

export type TResponseStatusPengaliranSkp = CommonResponse<StatusPengaliranSKP>

export const API_GET_STATUS_PENGALIRAN_SKP = 'API_GET_STATUS_PENGALIRAN_SKP'

export function useApiGetPengaliranSkpStatus(
  params: TRequestStatusPengaliranSkp,
  opts?: UQO<TResponseStatusPengaliranSkp>
) {
  const skpYear = params?.year || undefined
  const jabatan = params?.jabatan || undefined

  return useQueryApi<TResponseStatusPengaliranSkp>(
    `${apiPaths.ekin}/pengaliran/skp/status`,
    {
      axiosConfig: { params: { skp_year: skpYear, jabatan } },
      queryConfig: { useErrorBoundary: false, ...opts },
      queryKey: [API_GET_STATUS_PENGALIRAN_SKP, skpYear, jabatan],
    }
  )
}

export function useApiSyncSkpPerencanaan(
  opts?: UseMutationOptions<
    ResponseSyncSkpPerencanaan,
    Error,
    ParamsSyncSkpPerencanaan
  >
) {
  return useMutationApi(
    `${apiPaths.basePath}/v1/perencanaan-skp/sync/skp-to-bkn`,
    {
      axiosConfig: {
        method: 'POST',
      },
      mutationConfig: {
        ...opts,
      },
    }
  )
}
